import React from "react";
import { Formik, FormikProps } from "formik";
interface Props {
  initialValues: any;
  onSubmit: any;
  validationSchema?: any;
  children: React.ReactNode | ((props: FormikProps<any>) => React.ReactNode);
  innerRef?: any;
  validateOnChange?: boolean;
  divStyle?: React.CSSProperties;
  id?: string;
  disabled?: boolean;
  validateOnMount?: boolean;
  [otherProps: string]: any;
  enableReinitialize?: boolean;
}

const AppForm: React.FC<Props> = ({
  initialValues,
  onSubmit,
  validationSchema,
  innerRef,
  children,
  id = "",
  divStyle,
  validateOnChange = true,
  disabled = false,
  validateOnMount=false,
  ...otherProps
}) => {
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
      enableReinitialize={true}
      innerRef={innerRef}
      validateOnChange={validateOnChange}
      validateOnMount={validateOnMount}
      {...otherProps}
    >
      {(props: FormikProps<any>) => {
        return (
          <form
            onSubmit={props.handleSubmit}
            id={id}
            style={divStyle}
            className={`formikFormWrapper ${disabled ? "disableEntireForm" : ""}`} //DO NOT USE disableEntireForm for styling purpose only used to identify this component and disable conditional rendering
          >
          {typeof children === "function" ? children(props) : children}
          </form>
        );
      }}
    </Formik>
  );
};

export default AppForm;
